import * as OFMSUI from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { Formik, Field } from "formik";
import * as Yup from "yup";
import React, { useState } from "react";
import { Form } from "react-bootstrap";
import Swal, { swal } from "sweetalert2/dist/sweetalert2.js";
import { InputGroup } from "react-bootstrap";
import HousingService from "../../../Services/HousingService";
import NavigationServicesHeader from "../../../Header/NavigationServicesHeader";
import { useHistory } from "react-router";
//import {cloud_url} from  "../../Services/Configuration"
import axios from "axios";
import { cloud_url } from "../../../Services/Configuration";
import { FaFastBackward } from "react-icons/fa";

function BankEntryScreen() {
  const [bankNamesList, setbankNamesList] = useState();
  const [district, setindistrict] = useState();
  const [flag, setFlag] = useState(false);
  const [flag1, setFlag1] = useState(false);
  const [savefile, setSavefile] = useState("");
  let history = useHistory();

  const showNotification = (type, message) => {
    if (type === "success") {
      Swal.fire("Success", message, "success");
    } else if (type === "error") {
      Swal.fire("Error", message, "error");
    } else if (type === "warning") {
      Swal.fire("Warning", message, "warning");
    } else if (type === "info") {
      Swal.fire("info", message, "info");
    }
  };
  React.useEffect(() => {
    HousingService.fetchBankName().then((res) => {
      if (res.data) {
        let options = res.data.map((item, i) => {
          if (item !== null) {
            return (
              <option key={i} value={item.bankshortname}>
                {item.bankid}
                {"-"}
                {item.bankfullname}
              </option>
            );
          }
        });
        setbankNamesList(options);
      }
    });

    HousingService.fetchDistrictNames().then((res) => {
      const response = res.data[0].display_name;
      const username = localStorage.getItem("username");

      if (res.data) {
        if (username && username.includes("DH")) {
          const district = response;
          setindistrict(district);
        } else {
          setindistrict(response);
        }
      }
    });
  }, []);

  const NumberValidation = (e) => {
    var keyCode = e.keyCode === 0 ? e.charCode : e.keyCode;

    var value = Number(e.target.value + e.key) || 0;

    if (keyCode >= 48 && keyCode <= 57) {
      return isValidNumber(value);
    } else {
      e.preventDefault();
    }
    showNotification("warning", "enter digits only");
    return false;
  };
  function isValidNumber(number) {
    return 0 <= number && number <= 10;
  }
  const allowAlphabetAndSpacesOnly = (e) => {
    var keyCode = e.charCode;

    var value = Number(e.target.value + e.key) || 0;

    if (
      !(keyCode >= 65 && keyCode <= 123) &&
      keyCode !== 32 &&
      keyCode !== 0 &&
      keyCode !== 40 &&
      keyCode !== 41
    ) {
      e.preventDefault();
    } else {
      return value;
    }

    return false;
  };

  const onChangeAccount = (e, field, values, setValues) => {
    const joint = e.target.value;
    field.onChange(e);
    setFlag(true);
    setFlag1(true);
  };
  const onChangeAccountIndividual = (e, field, values, setValues) => {
    const individual = e.target.value;
    field.onChange(e);
    setFlag(false);
  };

  const [selectedFile, setSelectedFile] = useState(null);
  const [uploadedFile, setUploadedFile] = useState(null);
  const handleFileChange = (event) => {
    setSelectedFile(event.target.files[0]);
  };

  const handleUpload = () => {
    return new Promise((resolve, reject) => {
      const formData = new FormData();
      formData.append("file", selectedFile);

      axios
        .post(cloud_url + "/apofms/Pay_Rec", formData)
        .then((response) => {
          resolve(response.data);
          setSavefile(response.data);
        })
        .catch((error) => {
          resolve(null);
        });
    });
  };

  return (
    <>
      {" "}
      <NavigationServicesHeader />
      <Formik
        initialValues={{
          bankname: "",
          branchname: "",
          ifsc: "",
          accountno: "",
          operationaccount: "",
          accountholder1: "",
          accountholder2: "",
          balance: "",
          remaining_balance: "",
          accounttype: "",
          passbook_path: selectedFile
        }}
        onSubmit={async (values, { resetForm }) => {
          const uploadedData = await handleUpload(); // Upload the file
          setUploadedFile(uploadedData); // Set the uploaded data in the state
          values.passbook_path = uploadedData;
          let params = {
            "bankname": values.bankname,
            "ifsc": values.ifsc,
            "operationaccount": values.operationaccount,
            "accountholder1": values.accountholder1,
            "accountholder2": values.accountholder2,
            "accountno": values.accountno,
            "passbookpath":uploadedData,
            "branchname": values.branchname,
            "balance": values.balance,
            "remainingbalance": values.balance,
            "accounttype": values.accounttype,
          }

          Swal.fire({
            text: "Do you want Submit?",
            icon: "success",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes"
          }).then((result) => {
            if (result.isConfirmed) {
              HousingService.createBankEntryForm(params).then((response) => {
                if (response?.data?.SCODE === "01") {
                  showNotification("success", "Submitted successfully");
                  setTimeout(() => {
                    resetForm();
                    window.location.reload();
                  }, 1000);
                }
              });
            }
          });
        }}
        validationSchema={Yup.object({
          bankname: Yup.string().required(),
          ifsc: Yup.string()
            .required("IFSC code is required")
            .matches(/^[A-Z]{4}0[A-Z0-9]{6}$/, "Invalid IFSC code"),
          branchname: Yup.string().required(),
          // balance:Yup.number().required(),
          balance: Yup.string()
            .required("Balance is required")
            .matches(/^[0]$/, "Balance must be zero"),
          operationaccount: Yup.string().required(),
          accountno: Yup.string().required()
        })}
      >
        {({
          formik,
          errors,
          values,
          touched,
          setValues,
          handleSubmit,
          resetForm,
          setFieldValue,
          onChange
        }) => (
          <Form onSubmit={handleSubmit}>
            <OFMSUI.Container>
              <OFMSUI.Row>
                <OFMSUI.Col
                  xs={12}
                  sm={12}
                  md={12}
                  lg={6}
                  xl={6}
                  xxl={6}
                  className="page-titlespacing"
                >
                  <div className="inner-herbpage-service-title1">
                    <h1 style={{ marginLeft: "-15px" }}>BANK DETAILS ENTRY</h1>
                  </div>
                </OFMSUI.Col>

                <OFMSUI.Col
                  xs={12}
                  sm={12}
                  md={12}
                  lg={6}
                  xl={6}
                  xxl={6}
                  className="page-titlespacing"
                >
                  <button
                    className="btn btn-primary btn-sm"
                    style={{
                      textAlign: "right",
                      float: "right",
                      marginTop: "30px",
                      backgroundColor: "#603913",borderColor: "#603913", color: "#fff"
                    }}
                    type="reset"
                    onClick={() => history.goBack()}
                  >
                    <FaFastBackward /> &nbsp;Back
                  </button>
                </OFMSUI.Col>
              </OFMSUI.Row>
            </OFMSUI.Container>
            <OFMSUI.Container className="outer-page-content-container ">
              <OFMSUI.Row className="mb-3">
                <OFMSUI.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3}>
                  <OFMSUI.InputGroup className=" mt-4">
                    <span className="label-text-style">
                      <b>District Name</b>
                    </span>

                    <div className="emptyspace3">{district}</div>
                  </OFMSUI.InputGroup>
                </OFMSUI.Col>

                <OFMSUI.Col
                  xs={12}
                  sm={12}
                  md={12}
                  lg={3}
                  xl={3}
                  xxl={3}
                  className=""
                >
                  <label>
                    <b> Name of the Bank</b>
                  </label>
                  <span className="mandatory" style={{ color: "red" }}>
                    {" "}
                    *{" "}
                  </span>
                  <Field
                    component="select"
                    name="bankname"
                    className={
                      touched.bankname && errors.bankname
                        ? "form-control is-invalid"
                        : "form-control"
                    }
                  >
                    <option value="">--Select--</option>
                    {bankNamesList}
                  </Field>
                </OFMSUI.Col>
                <OFMSUI.Col
                  xs={12}
                  sm={12}
                  md={12}
                  lg={3}
                  xl={3}
                  xxl={3}
                  className=""
                >
                  <label>
                    <b>Branch Name</b>
                  </label>
                  <span className="mandatory" style={{ color: "red" }}>
                    {" "}
                    *{" "}
                  </span>
                  <Field
                    name="branchname"
                    className={
                      touched.branchname && errors.branchname
                        ? "form-control is-invalid"
                        : "form-control"
                    }
                    type="text"
                  />
                  {touched.branchname && errors.branchname ? (
                    <div className="invalid-feedback">{errors.branchname}</div>
                  ) : null}
                </OFMSUI.Col>
                <OFMSUI.Col
                  xs={12}
                  sm={12}
                  md={12}
                  lg={3}
                  xl={3}
                  xxl={3}
                  className=""
                >
                  <label>
                    <b>Account Number</b>
                  </label>
                  <span className="mandatory" style={{ color: "red" }}>
                    {" "}
                    *{" "}
                  </span>
                  <Field
                    name="accountno"
                    className={
                      touched.accountno && errors.accountno
                        ? "form-control is-invalid"
                        : "form-control"
                    }
                    onKeyPress={(e) => NumberValidation(e)}
                    type="text"
                    minlength="11"
                    maxLength="21"
                  />
                  {touched.accountno && errors.accountno ? (
                    <div className="invalid-feedback">{errors.accountno}</div>
                  ) : null}
                </OFMSUI.Col>
                <OFMSUI.Col
                  xs={12}
                  sm={12}
                  md={12}
                  lg={3}
                  xl={3}
                  xxl={3}
                  className=""
                >
                  {/* <label>
                    <b>IFSC Code</b>
                  </label>
                  <span className="mandatory" style={{ color: "red" }}>
                    {" "}
                    *{" "}
                  </span>
                  <Field
                    name="ifsc"
                    className={
                      touched.ifsc && errors.ifsc
                        ? "form-control is-invalid"
                        : "form-control"
                    }
                    type="text"
                   
                  />
                  {touched.ifsc && errors.ifsc ? (
                    <div className="invalid-feedback">{errors.ifsc}</div>
                  ) : null} */}
                  <label>
                    <b>IFSC Code</b>
                  </label>
                  <span className="mandatory" style={{ color: "red" }}>
                    {" "}
                    *{" "}
                  </span>
                  <Field
                    name="ifsc"
                    className={
                      touched.ifsc && errors.ifsc
                        ? "form-control is-invalid"
                        : "form-control"
                    }
                    type="text"
                  />
                  {touched.ifsc && errors.ifsc ? (
                    <div className="invalid-feedback">{errors.ifsc}</div>
                  ) : null}
                </OFMSUI.Col>
                <OFMSUI.Col
                  xs={12}
                  sm={12}
                  md={12}
                  lg={3}
                  xl={3}
                  xxl={3}
                  className=""
                >
                  <label>
                    <b>Balance</b>
                  </label>
                  <span className="mandatory" style={{ color: "red" }}>
                    {" "}
                    *{" "}
                  </span>
                  <Field
                    name="balance"
                    className={
                      touched.balance && errors.balance
                        ? "form-control is-invalid"
                        : "form-control"
                    }
                    type="text"

                    onKeyPress={(e) => NumberValidation(e)}
                  />
                  {touched.balance && errors.balance ? (
                    <div className="invalid-feedback">{errors.balance}</div>
                  ) : null}
                </OFMSUI.Col>
                <OFMSUI.Col
                  xs={12}
                  sm={12}
                  md={12}
                  lg={3}
                  xl={3}
                  xxl={3}
                  className=""
                >
                  <label>
                    <b>Operation of Account:</b>
                  </label>

                  <span className="mandatory" style={{ color: "red" }}>
                    {" "}
                    *{" "}
                  </span>
                  <div className="border  p-1 ">
                    <div
                      className="  form-check form-check-inline"
                      style={{ paddingLeft: "50px" }}
                    >
                      <Field name="operationaccount">
                        {({ field }) => (
                          <input
                            className="form-check-input"
                            {...field}
                            type="radio"
                            value="Joint"
                            onChange={(e) =>
                              onChangeAccount(e, field, values, setValues)
                            }
                          ></input>
                        )}
                      </Field>
                      {touched.operationaccount && errors.operationaccount ? (
                        <div className="invalid-feedback">
                          {errors.operationaccount}
                        </div>
                      ) : null}
                      {/* <Field name="accountoperation" value="Joint" type="radio" onChange={e => onChangeAccount(e, field, values, setValues)} /> */}

                      <label className="form-check-label">Joint</label>
                    </div>
                    <div className="form-check form-check-inline">
                      {/* <Field name="accountoperation" value="Individual" type="radio" /></span><span><label>Individual</label> */}
                      <Field name="operationaccount">
                        {({ field }) => (
                          <input
                            className="form-check-input"
                            {...field}
                            type="radio"
                            value="Individual"
                            onChange={(e) =>
                              onChangeAccountIndividual(
                                e,
                                field,
                                values,
                                setValues
                              )
                            }
                          ></input>
                        )}
                      </Field>
                      {touched.operationaccount && errors.operationaccount ? (
                        <div className="invalid-feedback">
                          {errors.operationaccount}
                        </div>
                      ) : null}
                      <label className="form-check-label">Individual</label>{" "}
                    </div>
                  </div>
                </OFMSUI.Col>

                <OFMSUI.Col
                  xs={12}
                  sm={12}
                  md={12}
                  lg={3}
                  xl={3}
                  xxl={3}
                  className=""
                >
                  <label>
                    <b> Type of Account:</b>
                  </label>
                  <span className="mandatory" style={{ color: "red" }}>
                    {" "}
                    *{" "}
                  </span>
                  <div className="border  p-1 ">
                    <div
                      className="  form-check form-check-inline"
                      style={{ paddingLeft: "50px" }}
                    >
                      <Field name="accounttype">
                        {({ field }) => (
                          <input
                            className="form-check-input"
                            {...field}
                            type="radio"
                            value="SB"
                            checked={field.value === "SB"} // Checked if the field value is "SB"
                          />
                        )}
                      </Field>
                      <label className="form-check-label">SB</label>
                    </div>
                    <div className="form-check form-check-inline">
                      <Field name="accounttype">
                        {({ field }) => (
                          <input
                            className="form-check-input"
                            {...field}
                            type="radio"
                            value="Current"
                            checked={field.value === "Current"} // Checked if the field value is "Current"
                          />
                        )}
                      </Field>
                      <label className="form-check-label">Current</label>
                    </div>
                  </div>
                </OFMSUI.Col>
              </OFMSUI.Row>
              <OFMSUI.Row style={{ marginTop: "1rem" }}>
                <div className="inner-herbpage-service-title-sub">
                  <h1> Account Holder Details</h1>
                </div>

                <OFMSUI.Col
                  xs={12}
                  sm={12}
                  md={12}
                  lg={3}
                  xl={3}
                  xxl={3}
                  className=""
                >
                  <label>
                    <b> Name 1</b>
                  </label>
                  <span className="mandatory" style={{ color: "red" }}>
                    {" "}
                    *{" "}
                  </span>
                  <Field
                    name="accountholder1"
                    className={
                      touched.accountholder1 && errors.accountholder1
                        ? "form-control is-invalid"
                        : "form-control"
                    }
                    type="text"
                  />
                  {touched.accountholder1 && errors.accountholder1 ? (
                    <div className="invalid-feedback">
                      {errors.accountholder1}
                    </div>
                  ) : null}
                </OFMSUI.Col>
                {flag && (
                  <>
                    <OFMSUI.Col
                      xs={12}
                      sm={12}
                      md={12}
                      lg={3}
                      xl={3}
                      xxl={3}
                      className=""
                    >
                      <label>
                        <b> Name 2</b>
                      </label>
                      <span className="mandatory" style={{ color: "red" }}>
                        {" "}
                        *{" "}
                      </span>
                      <Field
                        name="accountholder2"
                        className={
                          touched.accountholder2 && errors.accountholder2
                            ? "form-control is-invalid"
                            : "form-control"
                        }
                        type="text"
                      />

                      {touched.accountholder2 && errors.accountholder2 ? (
                        <div className="invalid-feedback">
                          {errors.accountholder2}
                        </div>
                      ) : null}
                    </OFMSUI.Col>
                  </>
                )}

                <OFMSUI.Col
                  xs={12}
                  sm={12}
                  md={12}
                  lg={5}
                  xl={5}
                  xxl={5}
                  className="m-2"
                >
                  <label>
                    <b>File Upload </b>
                    <span className="text-danger">*</span>
                  </label>
                  <InputGroup>
                    <input
                      type="file"
                      name="file"
                      onChange={handleFileChange}
                      className="form-control"
                      accept=".pdf"
                    />
                  </InputGroup>
                </OFMSUI.Col>
              </OFMSUI.Row>
              &nbsp;
              <OFMSUI.Row>
                <OFMSUI.Col
                  xs={12}
                  sm={12}
                  md={12}
                  lg={1}
                  xl={1}
                  xxl={1}
                  className=""
                >
                  <div className="d-grid">
                    <button
                      className="btn btn-secondary btn-sm "
                      type="reset"
                      onClick={resetForm}
                    >
                      Clear
                    </button>
                  </div>
                </OFMSUI.Col>

                <center>
                  <OFMSUI.Col xs={12} sm={12} md={12} lg={1} xl={1} xxl={1}>
                    {" "}
                    <button className="btn btn-success btn-sm" type="submit">
                      Submit
                    </button>
                  </OFMSUI.Col>
                </center>
              </OFMSUI.Row>
            </OFMSUI.Container>
          </Form>
        )}
      </Formik>
    </>
  );
}

export default BankEntryScreen;
